import IndexLayout from '../layouts';
import Wrapper from '../components/Wrapper';
import SiteNav from '../components/header/SiteNav';
import { SiteHeader, outer, inner, SiteMain } from '../styles/shared';
import * as React from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/core';
import { PostFullHeader, PostFullTitle, NoImage, PostFull } from '../templates/post';
import { PostFullContent } from '../components/PostContent';
import Footer from '../components/Footer';
import Helmet from 'react-helmet';

//import ShareButtons from '../components/ShareButtons';
import MoreGoodies from '../components/more-goodies/MoreGoodies';
import BackToTop from '../components/BackToTop';

const PageTemplate = css`
.site-main {
background #fff;
padding-bottom: 4vw;
}

.post-content {
max-width: 1000px;
margin: 0 auto;
}
.post-full-content {
  background: transparent;
}
p {
  font-size: 2rem !important;

}
h2::before {
all: unset !important;
}
h3 {
text-decoration: none !important;
padding-top: 5rem;
text-align: center;
}
`;

const Logo = styled.img`
  width: 64px;
  display: block;
  margin: 0 auto 1.2rem;
`;

const Visualizer = styled.img`
  width: 256px;
  display: block;
  margin: 0 auto;
`;

const Labels = styled.ul`
  padding: 0 !important;
  list-style: none;
  display: flex;
  justify-content: space-between;

  li {
    @media (max-width: 750px) {
      writing-mode: vertical-rl;
      text-orientation: mixed;
    }

    padding: 0;
    margin: 0;

    position: relative;
    text-align: left;
    color: #333;
    font-size: 1.8rem;
  }
  li.active {
    transform: scale(2);
  }
`;

const Range = styled.input`
  width: 100%;
  -webkit-appearance: none;
  margin: 6rem 0 4rem;
  background: transparent;

  :focus {
    outline: none;
  }
  ::-webkit-slider-runnable-track {
    width: 100%;
    height: 12.8px;
    cursor: pointer;
    animate: 0.2s;
    background: rgba(50, 186, 85, 0.36);
    border-radius: 10px;
  }
  ::-webkit-slider-thumb {
    // box-shadow: 0px 0px 0px #000000, 0px 0px 0px #333;
    box-shadow: 0 0 6px rgba(0, 0, 0, 0.2);
    border: 0px solid #000000;
    height: 40px;
    width: 40px;
    border-radius: 20px;
    background: radial-gradient(50% 50% at 50% 50%, #32BA55 0%, #19905E 100%);
    cursor: pointer;
    -webkit-appearance: none;
    margin-top: -13.6px;
  }
  :focus::-webkit-slider-runnable-track {
   // background: rgba(155, 89, 182, 0.6);
  }
  ::-moz-range-track {
    width: 100%;
    height: 12.8px;
    cursor: pointer;
    animate: 0.2s;
    // box-shadow: 0px 0px 0px #000000, 0px 0px 0px #0d0d0d;
    background: rgba(155, 89, 182, 0.4);
    border-radius: 15px;
    border: 0px solid #000101;
  }
  ::-moz-range-thumb {
    box-shadow: 0px 0px 0px #000000, 0px 0px 0px #0d0d0d;
    border: 0px solid #000000;
    height: 40px;
    width: 40px;
    border-radius: 20px;
    background: radial-gradient(#7e59c1, #382757);
    cursor: pointer;
  }
  ::-ms-track {
    width: 100%;
    height: 12.8px;
    cursor: pointer;
    animate: 0.2s;
    background: transparent;
    border-color: transparent;
    border-width: 39px 0;
    color: transparent;
  }
  ::-ms-fill-lower {
    background: #ac51b5;
    border: 0px solid #000101;
    border-radius: 50px;
    box-shadow: 0px 0px 0px #000000, 0px 0px 0px #0d0d0d;
  }
  ::-ms-fill-upper {
    background: #ac51b5;
    border: 0px solid #000101;
    border-radius: 50px;
    box-shadow: 0px 0px 0px #000000, 0px 0px 0px #0d0d0d;
  }
  ::-ms-thumb {
    box-shadow: 0px 0px 0px #000000, 0px 0px 0px #0d0d0d;
    border: 0px solid #000000;
    height: 20px;
    width: 39px;
    border-radius: 20px;
    background: #65001c;
    cursor: pointer;
  }
  :focus::-ms-fill-lower {
   // background: #ac51b5;
  }
  :focus::-ms-fill-upper {
   // background: #ac51b5;
  }
`;

const RememberBox = styled.div` 
  margin-top: 15rem;
  background: #EFFAF2;
  border-radius: 8px;
  padding: 1.3rem 1.3rem 0.45rem;

  @media (max-width: 750px) {
    padding: 0.1rem 0.1rem 0.1rem;
  }

  li:first-letter {
    color: #ACE3BA;
  }

  h3 {
    padding-top: 0;
  }
`;

const valuesToFileName = ['1.4', '2', '2.8', '4', '5.6', '8', '11', '16', '22', '32'];

interface ApertureVisualizerState {
  currentValue: number;
}

class ApertureVisualizer extends React.Component<undefined, ApertureVisualizerState> {
  state = {
    currentValue: 4,
  };

  handleChange = evt => {
    this.setState({ currentValue: +evt.target.value });
  };

  render() {
    return (
      <IndexLayout>
        <Helmet>
          <title>Aperture Visualizer | Giggster</title>
          <meta
            name="description"
            content="This free interactive tool will allow you to quickly visualize how aperture works and get a mental image for the f-stops."
          />

          <meta property="og:site_name" content="Giggster Guide" />
          <meta property="og:type" content="article" />
          <meta property="og:title" content="Aperture Visualizer" />
          <meta
            property="og:description"
            content="This free interactive tool will allow you to quickly visualize how aperture works and get a mental image for the f-stops."
          />
          <meta property="og:url" content="https://giggster.com/guide/aperture-visualizer/" />
          <meta property="og:image" content="https://giggster.com/guide/covers/r.png" />
          <meta property="article:publisher" content="https://www.facebook.com/giggsterHQ" />

          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:title" content="Aperture Visualizer" />
          <meta
            name="twitter:description"
            content="This free interactive tool will allow you to quickly visualize how aperture works and get a mental image for the f-stops."
          />
          <meta name="twitter:url" content="https://giggster.com/guide/aperture-visualizer/" />
          <meta
            name="twitter:image"
            content="https://giggster.com/guide/covers/aperture-visualizer.png"
          />
          <meta name="twitter:site" content="@Giggster" />
          <meta name="twitter:creator" content="@Giggster" />
        </Helmet>
        <Wrapper css={PageTemplate}>
          <header css={[outer, SiteHeader]}>
            <div css={inner}>
              <SiteNav />
            </div>
          </header>
          <main id="site-main" className="site-main" css={[SiteMain, outer]}>
            <article className="post page" css={[PostFull, NoImage]}>
              <PostFullHeader>
                <PostFullTitle>
                  <Logo src="/guide/images/apertures/aperture-visualizer-logo.svg" alt="" />
                  Aperture Visualizer
                </PostFullTitle>
                <h2 className="b3">Preview different apertures and f-stop numbers</h2>
                {/*<ShareButtons
                  title={'Lens Aperture Visualizer'}
                  slug={'/aperture-visualizer/'}
                  imgSrc={'covers/aperture-visualizer.png'}
                />*/}
                <p className="t3">
                  It can take a while for the brain to adjust to higher f-stop numbers meaning a
                  closed down aperture and vice versa. To better be able to assimilate that notion
                  I've put together this tool to easily visualize different apertures with the
                  corresponding f-stop number.
                </p>
                <p>Just drag the slider below to open or close the aperture:</p>
              </PostFullHeader>

              <PostFullContent className="post-full-content">
                <div className="post-content text-center">
                  <Visualizer
                    src={`/guide/images/apertures/f${valuesToFileName[this.state.currentValue]}.svg`}
                    alt="Aperture at f/5.6"
                  />

                  <Range
                    type="range"
                    min="0"
                    max="9"
                    step="1"
                    value={this.state.currentValue}
                    onChange={this.handleChange}
                  />
                  <Labels>
                    <li className={`${this.state.currentValue === 0 ? 'active' : ''}`}>f/1.4</li>
                    <li className={`${this.state.currentValue === 1 ? 'active' : ''}`}>f/2</li>
                    <li className={`${this.state.currentValue === 2 ? 'active' : ''}`}>f/2.8</li>
                    <li className={`${this.state.currentValue === 3 ? 'active' : ''}`}>f/4</li>
                    <li className={`${this.state.currentValue === 4 ? 'active' : ''}`}>f/5.6</li>
                    <li className={`${this.state.currentValue === 5 ? 'active' : ''}`}>f/8</li>
                    <li className={`${this.state.currentValue === 6 ? 'active' : ''}`}>f/11</li>
                    <li className={`${this.state.currentValue === 7 ? 'active' : ''}`}>f/16</li>
                    <li className={`${this.state.currentValue === 8 ? 'active' : ''}`}>f/22</li>
                    <li className={`${this.state.currentValue === 9 ? 'active' : ''}`}>f/32</li>
                  </Labels>

                  <RememberBox>
                    <h3>💡 Remember:</h3>
                    <ul>
                      <li>
                        &#9673; The Aperture is the opening in the lens that let light in to expose
                        the camera sensor.
                      </li>
                      <li>
                        &#9673; Wider apertures <strong>(smaller f-stop numbers)</strong> mean
                        shallower depth of field. Less will be in focus. This can be used for
                        creative effects.
                      </li>
                      <li>
                        &#9673; Apertures that are really closed-down (starting at around f/22 and
                        up) can cause diffraction. This varies with each lens, but it's generally a
                        good idea to avoid using very closed-down apertures for this reason.
                      </li>
                      <li>
                        &#9673; Along with shutter speed and ISO, aperture is the 3rd variable in
                        the &nbsp;
                        <a href="/guide/basics/exposure-triangle/">exposure triangle</a>.
                      </li>
                    </ul>
                  </RememberBox>
                </div>
              </PostFullContent>
            </article>
            <MoreGoodies slug="aperture-visualizer" />
          </main>
          <BackToTop />
          <Footer />
        </Wrapper>
      </IndexLayout>
    );
  }
}

export default ApertureVisualizer;
